import axios from "@axios"

export default {
  namespaced: true,
  actions: {
    fetchDeliveryZones(ctx, params) {
      return axios.get("/v1/delivery_zones", { params }).then((response) => {
        return response.data
      })
    },
  },
}
